import api from '@/api'

const { $pricing } = api;

export const { $referredCompanies } = $pricing;
